import axios from "axios";
import {url} from "../../../crudRequests";

// `isPatientAccess` and `patientId` used to be sent here. Until 2026-05-22 the
// server keyed its patient-side filter off `isPatientAccess === 'true'`, which
// meant a client could opt OUT of its own filtering by not sending it. The
// filter is now derived from the session (isPatientOwner) and the requested
// path, and the server reads neither param — so they are not sent, and must not
// be reintroduced. See routes/storage/patientFileAccess.js.
export function crudStorage(
  state,
  type,
  fileName,
  s3BucketName,
  directoryName,
  subdirectoryName,
  patientName
) {
  return axios({
    method: "GET",
    url: `${url}/crudStorage`,
    headers: {
      Authorization: "Bearer " + state.jwt,
    },
    params: {
      s3BucketName: s3BucketName || state.organization?.s3BucketName,
      id: state.patient?.pid || state.doctor?.did || state.admin?.id,
      type: type,
      fileName: fileName,
      directoryName: directoryName,
      subdirectoryName: subdirectoryName,
      patientName: patientName,
      db: state.db || 'blh'
    },
  });
}